// extracted by mini-css-extract-plugin
var _1 = "LGk4Snxc6Ku_Wpynq5yA";
export { _1 as "transition" }
